export enum Path {
  LOGIN = '/login/',
  PAYMENT = '/payment/',
  DASHBOARD = '/dashboard/',
  CREATEA_ACCOUNT = '/create-account/',
  REQUEST_DEMO = '/request-demo/',
  FORGOT_PASSWORD = '/forgot-password/',
  ACCOUNT_SUCCESS_CREATE = '/account-created/',
  ACCOUNT_ACTIVE = '/account-active/',
  PAYMENT_PENDING = '/payment-pending/',
  PROFILE = '/profile/',
  INVITATIONS = '/invitations/',
  My_TEAM = '/my-team/',
  PROFILE_EDIT = '/profile/edit/',
  UNDER_REVIEW = '/under-review/',
  TERMS_AND_CONDITIONS = '/terms-and-conditions/',
  TERMS_AND_CONDITIONS_2 = '/terms-and-conditions-2/',
  PRIVACY = '/privacy-policy/',
  PRIVACY_2 = '/privacy-policy-2/',
  BLOCKWALKS = '/blockwalks/',
  TEAM_REPORTING = '/team-reporting/',
  MY_CANDIDATES = '/my-candidates/',
  PAYMENT_METHOD = '/payment-method/',
  SURVEYS = '/surveys/',
}

export enum CityCouncilType {
  STATE_WIDE = 'Statewide',
  STATE_HOUSE = 'State House',
  STATE_SENATE = 'State Senate',
  CONGRESSIONAL = 'Congressional',
  COUNTY_WIDE = 'Countywide',
  CITY_WIDE = 'Citywide',
  COUNTY_COMMISSIONER = 'County Commissioner',
  SCHOOL_DISTRICT = 'School District',
  CITY_COUNCIL = 'City Council',
}

export enum SocketEvent {
  CANDIDATE_UPDATE = 'candidate.updated',
  INVITE_UPDATE = 'invite.updated',
  BLOCKWALK_UPDATE = 'blockwalk.updated',
  TAG_CREATED = 'tag.created',
  TAG_UPDATED = 'tag.updated.icon_color',
  UPDATE_CONTACT = 'update_contact',
}

export const enum DefaultLimit {
  Base = 10,
  Small = 20,
}
